import { useEffect, useState } from "react";

export const useSetConfigs = () => {
  const [isFinishedSettingConfigs, setIsFinishedSettingConfigs] = useState(false);

  useEffect(() => {
    if (isFinishedSettingConfigs) return;

    if (process.env.NODE_ENV === "development") {
      const config = {};

      for (const [key, value] of Object.entries(process.env)) {
        if (!key.startsWith("REACT_APP_")) continue;
        let parsedValue = value;

        if (value === "true") parsedValue = true;
        else if (value === "false") parsedValue = false;
        else if (!isNaN(value) && value.trim() !== "") parsedValue = Number(value);

        const strippedKey = key.slice("REACT_APP_".length);
        config[strippedKey] = parsedValue;
      }

      window._env_ = config;
      setIsFinishedSettingConfigs(true);
      return;
    }

    const fetchConfigs = async () => {
      const response = await fetch("/api/config");

      const json = await response.json();

      window._env_ = json;
      setIsFinishedSettingConfigs(true);
    };

    fetchConfigs();
  }, [isFinishedSettingConfigs]);

  return {
    isFinishedSettingConfigs
  };
};
